import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import cn from 'classnames';
import Context from '@bibliocommons/context';

import './FullScreenOverlayHeader.scss';

export function FullScreenOverlayHeader(props) {
  const { className, title, subtitle } = props;
  const { mobileApp } = useContext(Context);
  const classNames = cn('cp-full-screen-overlay-header', className, {
    'full-screen-overlay-header--mobile-app': mobileApp
  });
  return (
    <header className={classNames}>
      <h2 className="full-screen-overlay__title">{title}</h2>
      {subtitle && <div className="full-screen-overlay__subtitle">{subtitle}</div>}
    </header>
  );
}

FullScreenOverlayHeader.propTypes = {
  className: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};

export default FullScreenOverlayHeader;
